module.exports = __webpack_public_path__ + "@/assets/img/communities-icon.171797f4.svg";